<script>
    import AssetTypeObject from '@/components/page-filter-edit/AssetTypeObject.vue';

    export default {
        computed: {
            assetTypes() {return this.$store.getters.ASSET_TYPES}
        },
        components: {
            AssetTypeObject: AssetTypeObject,
        }
    }
</script>


<template>
    <AssetTypeObject
        v-for="(assetTypeValue, assetTypeIndex) in assetTypes" :key="assetTypeIndex"
        :assetType = "assetTypeValue"
    />
</template>